<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcnttninhbinh' }" @click="changeTab('hethongcnttninhbinh')">
        <a id="urlhethongcnttninhbinh" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/hethongcnttninhbinh" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xagiavan' } " @click="changeTab('Xagiavan')">
        <a id="urlXagiavan" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xagiavan" style="color: white;">Gia Vân</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xadaihoang' }" @click="changeTab('Xadaihoang')"  >
        <a id="urlXadaihoang" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xadaihoang" style="color: white;">Đại Hoàng</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xagiatran' }" @click="changeTab('Xagiatran')">
        <a id="urlXagiatran" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xagiatran" style="color: white;">Gia Trần</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaphongdoanh' }" @click="changeTab('Xaphongdoanh')" >
        <a id="urlXaphongdoanh" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xaphongdoanh" style="color: white;">Phong Doanh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xayyen' }" @click="changeTab('Xayyen')" >
        <a id="urlXayyen" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xayyen" style="color: white;">Ý Yên</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xayendong' }" @click="changeTab('Xayendong')" >
        <a id="urlXayendong" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xayendong" style="color: white;">Yên Đồng</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xagiaphong' }" @click="changeTab('Xagiaphong')" >
        <a id="urlXagiaphong" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xagiaphong" style="color: white;">Gia Phong</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xathanhson' }" @click="changeTab('Xathanhson')"  >
        <a id="urlXathanhson" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xathanhson" style="color: white;">Thanh Sơn</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xathanhlam' }" @click="changeTab('Xathanhlam')" >
        <a id="urlXathanhlam" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xathanhlam" style="color: white;">Thanh Lâm</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xathanhliem' }" @click="changeTab('Xathanhliem')" >
        <a id="urlXathanhliem" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xathanhliem" style="color: white;">Thanh Liêm</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xatanthanh' }" @click="changeTab('Xatanthanh')" >
        <a id="urlXatanthanh" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xatanthanh" style="color: white;">Tân Thanh</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xaliemha' }" @click="changeTab('Xaliemha')" >
        <a id="urlXaliemha" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xaliemha" style="color: white;">Liêm Hà</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xathanhbinh' }" @click="changeTab('Xathanhbinh')" >
        <a id="urlXathanhbinh" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xathanhbinh" style="color: white;">Thanh Bình</a>
      </li> 
      <li :class="{ topmenuactive: activeTab === 'Xabinhmy' }" @click="changeTab('Xabinhmy')" >
        <a id="urlXabinhmy" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xabinhmy" style="color: white;">Bình Mỹ</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xabinhan' }" @click="changeTab('Xabinhan')"  > 
        <a id="urlXabinhan" href="vi/chuongtrinhtaitroxathidiem#ninhbinh/xabinhan" style="color: white;">Bình An</a>
      </li>
    </ul>
  </nav>

  <div class="wrapper row3">
       <main class="hoc container-fluid clear bv p-0">

      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcnttninhbinh'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcnttninhbinh"></div>
        <div v-html="contentHtmlHethongcnttninhbinh || 'Đang cập nhập...'"></div>
        </div>
      <div v-if="showXagiavan" class="padding-top15"><strong>Gia Vân</strong><div v-html="contentHtmlXagiavan || 'Đang cập nhật...'"></div></div>
      <div v-if="showXadaihoang" class="padding-top15"><strong>Đại Hoàng</strong><div v-html="contentHtmlXadaihoang || 'Đang cập nhật...'"></div></div>
      <div v-if="showXagiatran" class="padding-top15"><strong>Gia Trần</strong><div v-html="contentHtmlXagiatran || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaphongdoanh" class="padding-top15"><strong>Phong Doanh</strong><div v-html="contentHtmlXaphongdoanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXayyen" class="padding-top15"><strong>Ý Yên</strong><div v-html="contentHtmlXayyen || 'Đang cập nhật...'"></div></div>
      <div v-if="showXayendong" class="padding-top15"><strong>Yên Đồng</strong><div v-html="contentHtmlXayendong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXagiaphong" class="padding-top15"><strong>Gia Phong</strong><div v-html="contentHtmlXagiaphong || 'Đang cập nhật...'"></div></div>      
      <div v-if="showXathanhson" class="padding-top15"><strong>Thanh Sơn</strong><div v-html="contentHtmlXathanhson || 'Đang cập nhật...'"></div></div>
      <div v-if="showXathanhlam" class="padding-top15"><strong>Thanh Lâm</strong><div v-html="contentHtmlXathanhlam || 'Đang cập nhật...'"></div></div>
      <div v-if="showXathanhliem" class="padding-top15"><strong>Thanh Liêm</strong><div v-html="contentHtmlXathanhliem || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatanthanh" class="padding-top15"><strong>Tân Thanh</strong><div v-html="contentHtmlXatanthanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaliemha" class="padding-top15"><strong>Liêm Hà</strong><div v-html="contentHtmlXaliemha || 'Đang cập nhật...'"></div></div>
      <div v-if="showXathanhbinh" class="padding-top15"><strong>Thanh Bình</strong><div v-html="contentHtmlXathanhbinh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXabinhmy" class="padding-top15"><strong>Bình Mỹ</strong><div v-html="contentHtmlXabinhmy || 'Đang cập nhật...'"></div></div>
      <div v-if="showXabinhan" class="padding-top15"><strong>Bình An</strong><div v-html="contentHtmlXabinhan || 'Đang cập nhật...'"></div></div>
    </main>
  </div>
</template>
<script scoped>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcnttninhbinh',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXagiatran: false,
      showXaphongdoanh: false,
      showXadaihoang: false,
      showCopilot: false,
      showGrok: false,
      showXayyen: false,
      showManus: false,
      showXagiavan: false,
      showXayendong: false,
      showXagiaphong: false,
      showUngDungAI: false,
      showXabinhan: false,
      showXathanhson: false,
      showXathanhlam: false,
      showXathanhliem: false,
      showXatanthanh: false,
      showXaliemha: false,
      showXathanhbinh: false,
      showXabinhmy: false,
      showHethongcnttninhbinh: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlXagiavan: "",
      titleHtmlXagiatran: "",
      titleHtmlXaphongdoanh: "",
      titleHtmlXadaihoang: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXayyen: "",
      titleHtmlXayendong: "",
      titleHtmlXagiaphong: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXabinhan: "",
      titleHtmlXathanhson: "",
      titleHtmlXathanhlam: "",
      titleHtmlXathanhliem: "",
      titleHtmlXatanthanh: "",
      titleHtmlXaliemha: "",
      titleHtmlXathanhbinh: "",
      titleHtmlXabinhmy: "",
titleHtmlHethongcnttninhbinh: "",
conttentHtmlHethongcnttninhbinh: "",

      contentHtmlXagiavan: "",
      contentHtmlXagiatran: "",
      contentHtmlXaphongdoanh: "",
      contentHtmlCopilot: "",
      contentHtmlXadaihoang: "",
      contentHtmlGrok: "",
      contentHtmlXayyen: "",
      contentHtmlXayendong: "",
      contentHtmlXagiaphong: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXabinhan: "",

      contentHtmlXathanhson: "",
      contentHtmlXathanhlam: "",
      contentHtmlXathanhliem: "",
      contentHtmlXatanthanh: "",
      contentHtmlXaliemha: "",
      contentHtmlXathanhbinh: "",
      contentHtmlXabinhmy: "",


    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages")   || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xagiatran", this.lang);
document.getElementById("urlhethongcnttninhbinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/hethongcntt");
      document.getElementById("urlXagiavan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xagiavan");
      document.getElementById("urlXadaihoang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xadaihoang");
      document.getElementById("urlXaphongdoanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xaphongdoanh");
      document.getElementById("urlXagiatran").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xagiatran");
      document.getElementById("urlXayyen").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xayyen");
      document.getElementById("urlXayendong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xayendong");
      document.getElementById("urlXagiaphong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xagiaphong");
      document.getElementById("urlXabinhan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xabinhan");
      document.getElementById("urlXathanhson").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xathanhson");
      document.getElementById("urlXathanhlam").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xathanhlam");
      document.getElementById("urlXathanhliem").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xathanhliem");
      document.getElementById("urlXatanthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xatanthanh");
      document.getElementById("urlXaliemha").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xaliemha");
      document.getElementById("urlXathanhbinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xathanhbinh");
      document.getElementById("urlXabinhmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/xabinhmy");


      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#ninhbinh/copilot/");




      let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
      // console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "ninhbinh/xagiavan") {
        this.changeTab("Xagiavan");
      } else if (fragmentTab === "ninhbinh/xadaihoang") {
        this.changeTab("Xadaihoang");
      } else if (fragmentTab === "ninhbinh/xaphongdoanh") {
        this.changeTab("Xaphongdoanh");
      } else if (fragmentTab === "ninhbinh/xagiatran") {
        this.changeTab("Xagiatran");
      } else if (fragmentTab === "ninhbinh/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "ninhbinh/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "ninhbinh/xayyen") {
        this.changeTab("Xayyen");
      } else if (fragmentTab === "ninhbinh/manus") {
        this.changeTab("Manus");
      } else if (fragmentTab === "ninhbinh/xayendong") {
        this.changeTab("Xayendong");
      }   else if (fragmentTab === "ninhbinh/xagiaphong") {
        this.changeTab("Xagiaphong");
      } else if (fragmentTab === "ninhbinh/xabinhan") {
        this.changeTab("Xabinhan");
      } else if (fragmentTab === "ninhbinh/xathanhson") {
        this.changeTab("Xathanhson");
      } else if (fragmentTab === "ninhbinh/xathanhlam") {
        this.changeTab("Xathanhlam");
      } else if (fragmentTab === "ninhbinh/xathanhliem") {
        this.changeTab("Xathanhliem");
      } else if (fragmentTab === "ninhbinh/xatanthanh") {
        this.changeTab("Xatanthanh");
      } else if (fragmentTab === "ninhbinh/xaliemha") {
        this.changeTab("Xaliemha");
      } else if (fragmentTab === "ninhbinh/xathanhbinh") {
        this.changeTab("Xathanhbinh");
      } else if (fragmentTab === "ninhbinh/xabinhmy") {
        this.changeTab("Xabinhmy");
      }
else if (fragmentTab === "ninhbinh/hethongcnttninhbinh") {
        this.changeTab("hethongcnttninhbinh");
}
       else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcnttninhbinh");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xagiatran") {
          this.titleHtmlXagiatran = decodeURIComponent(escape(title));
          this.contentHtmlXagiatran = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphongdoanh") {
          this.titleHtmlXaphongdoanh = decodeURIComponent(escape(title));
          this.contentHtmlXaphongdoanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadaihoang") {
          this.titleHtmlXadaihoang = decodeURIComponent(escape(title));
          this.contentHtmlXadaihoang = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xayyen") {
          this.titleHtmlXayyen = decodeURIComponent(escape(title));
          this.contentHtmlXayyen = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xagiavan") {
          this.titleHtmlXagiavan = decodeURIComponent(escape(title));
          this.contentHtmlXagiavan = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xayendong") {
          this.titleHtmlXayendong = decodeURIComponent(escape(title));
          this.contentHtmlXayendong = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xagiaphong") {
          this.titleHtmlXagiaphong = decodeURIComponent(escape(title));
          this.contentHtmlXagiaphong = decodeURIComponent(escape(decodedString));
        }else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhan") {
          this.titleHtmlXabinhan = decodeURIComponent(escape(title));
          this.contentHtmlXabinhan = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathanhson") {
          this.titleHtmlXathanhson = decodeURIComponent(escape(title));
          this.contentHtmlXathanhson = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathanhlam") {
          this.titleHtmlXathanhlam = decodeURIComponent(escape(title));
          this.contentHtmlXathanhlam = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathanhliem") {
          this.titleHtmlXathanhliem = decodeURIComponent(escape(title));
          this.contentHtmlXathanhliem = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatanthanh") {
          this.titleHtmlXatanthanh = decodeURIComponent(escape(title));
          this.contentHtmlXatanthanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaliemha") {
          this.titleHtmlXaliemha = decodeURIComponent(escape(title));
          this.contentHtmlXaliemha = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathanhbinh") {
          this.titleHtmlXathanhbinh = decodeURIComponent(escape(title));
          this.contentHtmlXathanhbinh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhmy") {
          this.titleHtmlXabinhmy = decodeURIComponent(escape(title));
          this.contentHtmlXabinhmy = decodeURIComponent(escape(decodedString));
        }else if (section === "hethongcnttninhbinh") {
          this.titleHtmlHethongcnttninhbinh = decodeURIComponent(escape(title));
          this.contentHtmlHethongcnttninhbinh = decodeURIComponent(escape(decodedString));
       
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xagiatran: false, Xaphongdoanh: false, Xadaihoang: false, Copilot: false, ungDungAI: false,
        Xagiavan: false, xayyen: false, Grok: false, Manus: false, Xayendong: false, Xagiaphong: false,
        Xabinhan: false, Xathanhson: false, Xathanhlam: false, Xathanhliem: false, Xatanthanh: false, Xaliemha: false, Xathanhbinh: false, Xabinhmy: false,
        hethongcnttninhbinh: false,
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXagiatran = tabStates.Xagiatran;
      this.showXaphongdoanh = tabStates.Xaphongdoanh;
      this.showXadaihoang = tabStates.Xadaihoang;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXayyen = tabStates.Xayyen;
      this.showManus = tabStates.Manus;
      this.showXagiavan = tabStates.Xagiavan;
      this.showXayendong = tabStates.Xayendong;
      this.showXagiaphong = tabStates.Xagiaphong;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXabinhan = tabStates.Xabinhan;
      this.showXathanhson = tabStates.Xathanhson;
      this.showXathanhlam = tabStates.Xathanhlam;
      this.showXathanhliem = tabStates.Xathanhliem;
      this.showXatanthanh = tabStates.Xatanthanh;
      this.showXaliemha = tabStates.Xaliemha;
      this.showXathanhbinh = tabStates.Xathanhbinh;

      this.showXabinhmy = tabStates.Xabinhmy;
      this.showHethongcnttninhbinh = tabStates.hethongcnttninhbinh;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xagiatran: "1758094446267NmFc1",
        Xaphongdoanh: "1758094475743IwoYv",
        Xadaihoang: "1758094416029RV81n",
        Copilot: "",
        Grok: "",
        Xayyen: "1758094507306Tdaex",
        Manus: "",
        Xagiavan: "17580943853612oGgH",
        Xayendong: "1758094536545tPycV", 
        Xagiaphong: "17580945659374hj7H",        
        UngDungAI: "",   
        Xabinhan: "1758094806274LfZ0b",   
        Xathanhson: "1758094596837BX0EZ", 
        Xathanhlam: "1758094626602FF1gI",  
        Xathanhliem: "1758094657872bwfdc", 
        Xatanthanh: "17580946863116Vkhk",    
        Xaliemha: "1758094715721ILyPq",     
        Xathanhbinh: "1758094746276I9l1f",   
        Xabinhmy: "17580947765663QNbf",    
        hethongcnttninhbinh: "1757648423941mMf3F", 
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
